import React, { useEffect, useState } from "react";
import "styles/slider.css";

const Slider = ({
  children,
  showIndicators = true,
  showButtons = true,
  showAlternButtons = false,
  arrowColor = "#0c3249",
  arrowColorActive = "#ffaf45",
  colorIndicator = "#0c3249",
  position = "absolute",
  positionIndicators = "10px",
  totalSlidesSend = 0,
  autoSlideInterval = 6,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const totalSlides =
    totalSlidesSend > 0 ? totalSlidesSend : React.Children.count(children);

  useEffect(() => {
    if (totalSlides > 0 && currentIndex >= totalSlides) {
      setCurrentIndex(0);
    }
  }, [totalSlides, currentIndex]);

  useEffect(() => {
    // Si el autoSlideInterval es mayor que 0, configurar el intervalo
    if (autoSlideInterval > 0) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
      }, autoSlideInterval * 1000); // Convertimos segundos a milisegundos

      // Limpiar el intervalo cuando el componente se desmonte o cuando cambien los slides
      return () => clearInterval(intervalId);
    }
  }, [autoSlideInterval, totalSlides]);

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  };

  const goToPrevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="slider-container">
      <div
        className="slider-content"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {React.Children.map(children, (child, index) => (
          <div
            className={`slide ${index === currentIndex ? "active" : ""}`}
            key={index}
          >
            {child}
          </div>
        ))}
      </div>
      
      {/* Flechas laterales circulares - nuevo diseño luxury */}
      {showButtons && (
        <>
          <button 
            onClick={goToPrevSlide} 
            className="slider-arrow slider-arrow--prev"
            aria-label="Anterior"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 12H2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button 
            onClick={goToNextSlide} 
            className="slider-arrow slider-arrow--next"
            aria-label="Siguiente"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M2 12h20" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M15 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </>
      )}

      {/* Indicadores/dots en la parte inferior */}
      {showIndicators && (
        <div className="slider-dots">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentIndex ? "slider-dot--active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Ir a slide ${index + 1}`}
            />
          ))}
        </div>
      )}
      
      {/* Mantener compatibilidad con estilo alternativo */}
      {showAlternButtons && (
        <>
          <button 
            onClick={goToPrevSlide} 
            className="alternative-btn prev"
            aria-label="Anterior"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button 
            onClick={goToNextSlide} 
            className="alternative-btn next"
            aria-label="Siguiente"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </>
      )}
    </div>
  );
};

export default Slider;
